import { render, staticRenderFns } from "./customRoleType.vue?vue&type=template&id=261000d4&"
import script from "./customRoleType.vue?vue&type=script&lang=js&"
export * from "./customRoleType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports